export type SkinType =
  | 'Hormonale huid'
  | 'Droge huid'
  | 'Gevoelige huid'
  | 'Rijpere huid'
  | 'Vette huid'
  | 'Pigmentatie'

export type Product = {
  id: string
  name: string
  brand: 'emerginC' | 'Flower & Spice' | 'Raaw by Trice' | 'Inika Organics'
  category: 'Serum' | 'Crème' | 'Reiniging' | 'Olie' | 'Masker' | 'SPF'
  price: number
  image: string
  skinTypes: SkinType[]
  note: string
  bestseller?: boolean
  salonFavourite?: boolean
}

export const skinTypes: SkinType[] = [
  'Hormonale huid',
  'Pigmentatie',
  'Droge huid',
  'Gevoelige huid',
  'Rijpere huid',
  'Vette huid',
]

export const brands = [
  {
    name: 'emerginC',
    description:
      'Cosmeceutical: ingrediënten die bijna medicinaal werken. Eigen stay-C formule voor stabiele vitamine C, astaxanthine en wortelzaadolie. Voor elk verkocht product wordt een boom geplant.',
  },
  {
    name: 'Flower & Spice',
    description:
      'Modern apothecary. Rijke, botanische formules met rozen, koriander en prickly pear — bewust samengesteld, zonder opvulling.',
  },
  {
    name: 'Raaw by Trice',
    description:
      'Nederlandse plantbased lijn met heldere, eerlijke ingrediëntenlijsten en herbruikbare verpakkingen.',
  },
  {
    name: 'Inika Organics',
    description:
      'Gecertificeerd biologische make-up en huidverzorging, ontwikkeld voor de gevoelige huid.',
  },
]

const SERUM =
  'https://cdn.magicpatterns.com/patterns/generated-images/bad357d4-4126-4b56-ba36-2130c1d62f4c.jpg'
const CREAM =
  'https://cdn.magicpatterns.com/patterns/generated-images/426830d8-8223-4ade-b3ce-0ffd186f4146.jpg'
const CLEANSER =
  'https://cdn.magicpatterns.com/patterns/generated-images/489a2ea1-4da0-43e3-9226-a1bb9f1ce3dd.jpg'
const OIL =
  'https://cdn.magicpatterns.com/patterns/generated-images/9d64e098-627e-4dab-93a2-8687234abcf0.jpg'
const FLOWERSPICE =
  'https://cdn.magicpatterns.com/uploads/rWx56TqkqpdAq1p3r54Crp/pasted-image.jpg'

export const products: Product[] = [
  {
    id: 'ec-vitamin-c',
    name: 'Vitamin C Serum (stay-C)',
    brand: 'emerginC',
    category: 'Serum',
    price: 78,
    image: SERUM,
    skinTypes: ['Pigmentatie', 'Hormonale huid', 'Rijpere huid'],
    note: 'Hét product bij de bindweefselmassage. Stabiele vitamine C tegen pigment en doffe teint.',
    bestseller: true,
    salonFavourite: true,
  },
  {
    id: 'ec-spf30-tinted',
    name: 'SPF 30+ Sun Tinted',
    brand: 'emerginC',
    category: 'SPF',
    price: 54,
    image: CLEANSER,
    skinTypes: ['Pigmentatie', 'Droge huid', 'Vette huid'],
    note: 'Egaal tintje én bescherming. In combinatie met het vitamine C serum perfect bij pigmentvlekken.',
    bestseller: true,
  },
  {
    id: 'fs-soothe-repair',
    name: 'Soothe & Repair Daily Moisturiser',
    brand: 'Flower & Spice',
    category: 'Crème',
    price: 62,
    image: FLOWERSPICE,
    skinTypes: ['Gevoelige huid', 'Droge huid'],
    note: 'Rose & coriander met prickly pear. Kalmeert een huid die snel rood aanloopt.',
    salonFavourite: true,
  },
  {
    id: 'ec-hydra-cleanser',
    name: 'Gentle Cleansing Milk',
    brand: 'emerginC',
    category: 'Reiniging',
    price: 42,
    image: CLEANSER,
    skinTypes: ['Gevoelige huid', 'Droge huid', 'Hormonale huid'],
    note: 'Reinigt zonder je huid te strippen — ook bij rosacea en ontstekinkjes.',
  },
  {
    id: 'raaw-balance-oil',
    name: 'Balancing Facial Oil',
    brand: 'Raaw by Trice',
    category: 'Olie',
    price: 49,
    image: OIL,
    skinTypes: ['Hormonale huid', 'Droge huid'],
    note: 'Brengt talg in balans in plaats van poriën te blokkeren. Geen kokos, geen vulling.',
  },
  {
    id: 'ec-retinol',
    name: 'Retinol Night Renewal',
    brand: 'emerginC',
    category: 'Serum',
    price: 92,
    image: SERUM,
    skinTypes: ['Rijpere huid', 'Vette huid'],
    note: 'Ingekapselde retinol: celvernieuwing zonder de barrière af te breken.',
  },
  {
    id: 'ec-clay-mask',
    name: 'Detox Clay Masker',
    brand: 'emerginC',
    category: 'Masker',
    price: 46,
    image: CREAM,
    skinTypes: ['Vette huid', 'Hormonale huid'],
    note: 'Trekt onzuiverheden weg en kalmeert tegelijk de roodheid eromheen.',
  },
  {
    id: 'inika-hydra-cream',
    name: 'Phytofuse Renew Crème',
    brand: 'Inika Organics',
    category: 'Crème',
    price: 58,
    image: CREAM,
    skinTypes: ['Gevoelige huid', 'Rijpere huid'],
    note: 'Gecertificeerd biologisch, met resveratrol. Voor een dunner wordende, reactieve huid.',
  },
  {
    id: 'fs-rosehip-oil',
    name: 'Nourishing Rosehip Oil',
    brand: 'Flower & Spice',
    category: 'Olie',
    price: 52,
    image: OIL,
    skinTypes: ['Rijpere huid', 'Droge huid', 'Gevoelige huid'],
    note: 'Voedt ’s nachts en verzacht littekentjes, zonder film achter te laten.',
  },
]
